import { connect } from 'react-redux';

import Box from '@mui/material/Box';

export const BANNER_LINE_HEIGHT = '2rem';

const Banner = ({ profile }) => {
  const banner = profile?.company?.banner;

  if (!banner?.enabled) return;

  return (
    <Box style={{
      backgroundColor: banner?.color,
      color: 'white',
      lineHeight: BANNER_LINE_HEIGHT,
      position: 'fixed',
      textAlign: 'center',
      width: '100%',
      zIndex: 3,
    }}>{ banner?.text }</Box>
  )
}

export default connect(({ profile }) => ({ profile }))(Banner);
